import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Profile, PaymentInfo, CreditCardInfo } from '../../models/profile.model';
import { NotificationBuilder } from '../../shared/notificationBuilder'
import { forkJoin, Observable } from 'rxjs';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { PlanService } from 'src/app/services/plan.service';
import { PlanItem } from 'src/app/models/planItem';
import { ProfileService } from 'src/app/profile/profile.service';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'planItens-viewer',
  templateUrl: './planItens-viewer.component.html',
  styleUrls: ['./planItens-viewer.component.css']
})
export class PlanItensViewerComponent implements OnInit {

  @Input() seoUrl: string
  @Input() profile: Profile
  @Output() answer = new EventEmitter();
  planItens: Array<PlanItem>
  public isAdmin: boolean
  loading: boolean
  loadingMessage = "Por favor, aguarde";


  tipagem: string;

  //usado para o PlanEditor
  planEditorSeoUrl: string = null;
  planEditorPlanItemId: string = null;

  constructor(
    private router: Router,
    private profileService: ProfileService,
    private authenticationService: AuthenticationService, private planService: PlanService, public ngxSmartModalService: NgxSmartModalService, private notificationBuilder: NotificationBuilder) {
  }

  ngOnInit() { }

  ngOnChanges() {
    debugger
    this.isAdmin = this.authenticationService.isAdministrator()

    // if (this.authenticationService.isAdministrator())
    //   this.router.navigate(['/'])

    if (this.seoUrl != null) {
      this.profileService.getCurrentUserInfo(this.seoUrl).subscribe(profile => {
        this.planService.adminGetAllPlanItensByStore(this.seoUrl).subscribe(planItens => {
          this.profile = profile
          console.log(profile)
          if (planItens.success)
            this.planItens = planItens.data

        })
      })
    }
    else {
      this.planService.adminGetAllPlanItensByStore().subscribe(planItens => {
        if (planItens.success)
          this.planItens = planItens.data
      })
    }

  }

  getPeriod(period: number): string {
    switch (period) {
      case 1:
        return "Mensal";
      case 2:
        return "Bimestral";
      case 3:
        return "Trimestral";
      case 4:
        return "Quadrimestral";
      case 5:
        return "Quinquemestral";
      case 6:
        return "Semestral";
      case 7:
        return "Septimestral";
      case 8:
        return "Octomestral";
      case 9:
        return "Nonamestral";
      case 10:
        return "Decemestral";
      case 11:
        return "Andecamestral"
      case 12:
      default:
        return "Anual";

    }
  }


  editPlanItem(planItem: PlanItem) {
    console.log('entrou');
    debugger
    if (planItem != null) {
      this.planEditorSeoUrl = this.profile.storeSeoName
      this.planEditorPlanItemId = planItem.id
    }
    else {
      this.planEditorSeoUrl = this.profile.storeSeoName
    }
  }

  deletePlanItem(planItem: PlanItem) {
    console.log('entrou');
    this.planService.adminDeletePlanItem(planItem.id, this.profile.storeSeoName).subscribe(res => {
      if (res.success)
        window.location.reload()

    })    
  }

  getAnswer(step: string, form: any) {
    debugger
    if (step == 'planEditor') {
      this.planEditorSeoUrl = null
      this.planEditorPlanItemId = null
    }
  }
}
